export default __webpack_public_path__ + "static/media/FOS_Vanquis.ec641ff8.pdf";